import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    color: idsTokens.accordion.default.color.header.text.enabled,
    minHeight: 'unset',
    minWidth: idsTokens.accordion.default.spacing.standard.collapsed.min.width,
    width: '100%',
    backgroundColor: idsTokens.accordion.default.color.header.collapsed.background.enabled,
    paddingTop: idsTokens.accordion.default.spacing.standard.collapsed.padding.top,
    paddingBottom: idsTokens.accordion.default.spacing.standard.collapsed.padding.bottom,
    paddingLeft: idsTokens.accordion.default.spacing.standard.collapsed.padding.left,
    paddingRight: idsTokens.accordion.default.spacing.standard.collapsed.padding.right,
    display: 'flex',
    alignItems: 'center',
    borderRadius: idsTokens.accordion.default.radius.header,
    borderTop: 0,
    borderBottom: `1px solid ${idsTokens.accordion.default.color.divider.enabled}`,
    boxSizing: 'border-box',
    '& .MuiAccordionSummary-content > .MuiTypography-root.subTitleText': {
      color: idsTokens.accordion.default.color.sublabel.enabled,
      fontSize: idsTokens.typography.font.size.sm,
      lineHeight: idsTokens.typography.lineHeight.sm,
      letterSpacing: idsTokens.typography.spacing.letter.md,
      fontWeight: idsTokens.typography.font.weight.regular,
    },
    '&:hover': {
      background: idsTokens.accordion.default.color.header.collapsed.background.hover,
      color: idsTokens.accordion.default.color.header.text.hover,
      borderBottom: `1px solid ${idsTokens.accordion.default.color.divider.hover}`,
      '& .MuiAccordionSummary-content > .subTitleText': {
        color: idsTokens.accordion.default.color.sublabel.hover,
      },
      '& + .MuiCollapse-root .MuiAccordionDetails-root': {
        backgroundColor: idsTokens.accordion.default.color.body.background.hover,
        color: idsTokens.accordion.default.color.body.text.hover,
      },
    },
    '&:active': {
      background: idsTokens.accordion.default.color.header.collapsed.background.pressed,
      color: idsTokens.accordion.default.color.header.text.pressed,
      borderBottom: `1px solid ${idsTokens.accordion.default.color.divider.pressed}`,
      '& .MuiAccordionSummary-content > .subTitleText': {
        color: idsTokens.accordion.default.color.sublabel.pressed,
      },
      '& + .MuiCollapse-root .MuiAccordionDetails-root': {
        backgroundColor: idsTokens.accordion.default.color.body.background.pressed,
        color: idsTokens.accordion.default.color.body.text.pressed,
      },
    },
    '&.Mui-focusVisible': {
      outlineColor: idsTokens.functional.color.border.focus,
      outlineOffset: -2,
      outlineStyle: 'solid',
      outlineWidth: idsTokens.functional.borderWidth.focus.default,
      backgroundColor: idsTokens.accordion.default.color.header.collapsed.background.enabled,
      borderRadius: idsTokens.accordion.default.radius.header,
      '& .MuiAccordionSummary-content > .subTitleText': {
        color: idsTokens.accordion.default.color.sublabel.focus,
      },
      '& + .MuiCollapse-root .MuiAccordionDetails-root': {
        backgroundColor: idsTokens.accordion.default.color.body.background.focus,
        color: idsTokens.accordion.default.color.body.text.focus,
      },
    },
    '&.Mui-expanded': {
      minWidth: idsTokens.accordion.default.spacing.standard.expanded.header.min.width,
      color: idsTokens.accordion.default.color.header.text.enabled,
      paddingTop: idsTokens.accordion.default.spacing.standard.expanded.header.padding.top,
      paddingBottom: idsTokens.accordion.default.spacing.standard.expanded.header.padding.bottom,
      paddingLeft: idsTokens.accordion.default.spacing.standard.expanded.header.padding.left,
      paddingRight: idsTokens.accordion.default.spacing.standard.expanded.header.padding.right,
      backgroundColor: idsTokens.accordion.default.color.expanded.background.enabled,
      borderBottom: '1px solid transparent',
      '&:hover': {
        background: idsTokens.accordion.default.color.expanded.background.hover,
        color: idsTokens.accordion.default.color.header.text.hover,
      },
      '&:active': {
        background: idsTokens.accordion.default.color.expanded.background.pressed,
        color: idsTokens.accordion.default.color.header.text.pressed,
      },
      '&.Mui-focusVisible': {
        backgroundColor: idsTokens.accordion.default.color.expanded.background.enabled,
      },
    },
  },
  content: {
    lineHeight: '24px',
    margin: 0,
    alignItems: 'center',
    display: 'block',
    width: '100%',
    marginLeft: `calc(${idsTokens.accordion.default.spacing.standard.collapsed.padding.gap} + 20px)`,
    '&.Mui-expanded': {
      margin: 0,
      marginLeft: `calc(${idsTokens.accordion.default.spacing.standard.collapsed.padding.gap} + 20px)`,
      lineHeight: '24px',
    },
  },
  expandIconWrapper: {
    left: '8px !important',
    top: '23.22px !important',
    paddingTop: 10,
    paddingBottom: 4,
    '&.Mui-expanded': {
      paddingTop: 6,
      left: '10px !important',
    },
  },
});
